import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { navigationItems } from "../navigation/navigations";

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);

  // Check if user is authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If no specific roles required, allow access
  if (requiredRoles.length === 0) {
    return children;
  }

  // Check if user has required role
  const hasAnyRole = (roles) => {
    if (!user) return false;

    // Support both old roles array and new type field
    let userRoles = [];

    if (user.roles && Array.isArray(user.roles)) {
      // Old Keycloak structure with roles array
      userRoles = user.roles.map((r) => r.toLowerCase());
    } else if (user.type) {
      // New structure with type field
      // Map user types to roles
      const typeToRoleMap = {
        SuperAdmin: [
          "superadmin",
          "restaurantadmin",
          "admin",
          "manager",
          "user",
        ],
        RestaurantAdmin: ["restaurantadmin", "admin", "manager", "user"],
        admin: ["admin", "manager", "user"],
        manager: ["manager", "user"],
        cashier: ["cashier", "user"],
        waiter: ["waiter", "user"],
        kitchen_staff: ["kitchen_staff", "user"],
      };

      userRoles = typeToRoleMap[user.type] || [user.type.toLowerCase()];
    }

    console.log("ProtectedRoute - User roles:", userRoles);
    console.log("ProtectedRoute - Required roles:", roles);

    const hasAccess = roles.some((role) =>
      userRoles.includes(role.toLowerCase()),
    );
    console.log("ProtectedRoute - Has access:", hasAccess);

    return hasAccess;
  };

  if (requiredRoles.length && !hasAnyRole(requiredRoles)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

// Helper function to get required roles for a path
export const getRequiredRoles = (path) => {
  const findRoles = (items) => {
    for (const item of items) {
      if (item.path === path) {
        return item.roles;
      }
      if (item.submenu) {
        const subRoles = findRoles(item.submenu);
        if (subRoles) return subRoles;
      }
    }
    return null;
  };

  return findRoles(navigationItems) || ["admin", "user"];
};

export default ProtectedRoute;
